<template>
  <section id="delivery-enquiry">
    <span v-if="isCourierDelivery() || isDeliveryTypeUnknown() || this.getTrackingOverride()">
      <router-link id="link_delivery-enquiry_courier-problem" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/courier-problem">My customer has received their parcel but has a problem</router-link>
      <router-link id="link_delivery-enquiry_courier-no-parcel" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/courier-no-parcel">Tracking says parcel delivered but my customer does not have it</router-link>
      <router-link id="link_delivery-enquiry_courier-no-delivery" v-if="isNotDelivered() || this.getTrackingOverride()" to="/delivery-enquiry/courier-no-delivery">My parcel hasn't been delivered yet</router-link>
    </span>

    <span v-if="isParcelShopDelivery() || this.getTrackingOverride()">
      <router-link id="link_delivery-enquiry_parcelshop-problem" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/parcelshop-problem">My customer has received their parcel but has a problem</router-link>
      <router-link id="link_delivery-enquiry_parcelshop-no-parcel" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/parcelshop-no-parcel">Tracking says parcel is at the ParcelShop but my customer doesn't have it</router-link>
      <router-link id="link_delivery-enquiry_parcelshop-no-delivery" v-if="isNotDelivered() || this.getTrackingOverride()" to="/delivery-enquiry/parcelshop-no-delivery">My parcel hasn't been delivered to my ParcelShop yet</router-link>
    </span>

    <span v-if="isLockerDelivery() || this.getTrackingOverride()">
      <router-link id="link_delivery-enquiry_locker-problem" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/locker-problem">My customer has received their parcel but has a problem</router-link>
      <router-link id="link_delivery-enquiry_locker-no-parcel" v-if="isDeliveryIssue() || this.getTrackingOverride()" to="/delivery-enquiry/locker-no-parcel">Tracking says parcel is at the Locker but my customer doesn't have it</router-link>
      <router-link id="link_delivery-enquiry_locker-no-delivery" v-if="isNotDelivered() || this.getTrackingOverride()" to="/delivery-enquiry/locker-no-delivery">My parcel hasn't been delivered to my Locker yet</router-link>
    </span>

    <router-link id="link_delivery_enquiry_instructions" v-if="isDeliveryInstructions() || this.getTrackingOverride()" to="/delivery-enquiry/instructions">I want to provide some delivery instructions</router-link>
    <router-link id="link_delivery-enquiry_critical" v-if="isStage('2','3') && !this.isReturnBarcode()" to="/delivery-enquiry/critical">I need to report a critical issue</router-link>
    <router-view></router-view>
  </section>
</template>


<script>
import { mapState } from "vuex";
import trackingJS from '../helpers/tracking.js';

export default {
  mixins: [trackingJS],
  computed: {
    ...mapState({
      tracking: state => state.tracking
    })
  },
  methods: {
    isDeliveryTypeUnknown() { return !this.tracking.deliveryMethod ||  this.tracking.deliveryMethod === '' },
    isCourierDelivery() { return this.tracking.deliveryMethod === 'Courier' },
    isParcelShopDelivery() { return this.tracking.deliveryMethod === 'ParcelShop' },
    isLockerDelivery() { return this.tracking.deliveryMethod === 'Locker' },
    isDeliveryIssue() { return this.isStage('5') },
    isNotDelivered() { return this.isStage('1', '2', '3', '4', '6') },
    isDeliveryInstructions() { return this.isStage('2', '3', '4', '6') },
    isStage(...stages) {
      return stages.indexOf(this.tracking.stage) !== -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/DeliveryEnquiry.vue